import type { StoreActions } from '../../types';

export const setVotedCards =
	(card: string) =>
	({ setState, getState }: StoreActions) =>
		setState({ ...getState(), votedCards: [...getState().votedCards, card] });
